import { defineFeature, defineModule, definePermission } from '@shared/contract'

// Pfand & Leergut (Branchenmodul, Funktionsschalter „deposits“): Pfandarten mit datierten Beträgen und
// Bestandteilen, Leergutkonten für Kunden und Lieferanten, Leergutbestand je Standort, Leergutrücknahme vom Kunden
// und Leergutrückgabe an den Lieferanten.
//
// Rechte (db/seeds/demo/roles.ts, Abschnitt „Pfand und Leergut“):
//   * Pfandarten und Leergutkonten gelten für den ganzen Betrieb (mandantenweite Rechte).
//   * Rücknahme und Rückgabe geschehen an einem Standort – diese Rechte sind je Standort vergebbar.
//   * Ein Konto wird nie still geändert: Korrekturen sind Belege mit Grund (`account.adjust`), ebenso das Storno
//     einer Rücknahme oder Rückgabe.
const GROUP = 'Pfand und Leergut'

export default defineModule({
  id: 'deposits',
  title: 'Pfand & Leergut',
  description: 'Pfandarten, Leergutkonten für Kunden und Lieferanten, Leergutbestand, Rücknahme und Rückgabe von Leergut.',
  dependsOn: ['platform', 'masterdata'],
  requiresFeature: 'deposits',
  features: [
    defineFeature({
      key: 'deposits',
      label: 'Pfand und Leergut',
      description: 'Pfandarten, Leergutkonten für Kunden und Lieferanten, Leergutbestand je Standort.',
      defaultEnabled: false,
    }),
  ],
  permissions: [
    definePermission({ key: 'deposits.type.read', label: 'Pfandarten lesen', group: GROUP, locationScoped: false }),
    definePermission({
      key: 'deposits.type.write',
      label: 'Pfandarten und Pfandbeträge pflegen',
      group: GROUP,
      description: 'Pfandarten anlegen, Beträge mit Stichtag ändern, Bestandteile eines Gebindepfands festlegen.',
      locationScoped: false,
    }),
    definePermission({
      key: 'deposits.account.read',
      label: 'Leergutkonten lesen',
      group: GROUP,
      description: 'Salden und Auszüge der Leergutkonten von Kunden und Lieferanten.',
      locationScoped: false,
    }),
    definePermission({
      key: 'deposits.account.adjust',
      label: 'Leergutkonten korrigieren und Leergutbelege stornieren',
      group: GROUP,
      description: 'Korrektur als Beleg mit Grund – nie eine stille Änderung. Auch das Storno einer Rücknahme oder Rückgabe.',
      locationScoped: false,
    }),
    definePermission({
      key: 'deposits.stock.read',
      label: 'Leergutbestand lesen',
      group: GROUP,
      description: 'Leergut je Pfandart an den eigenen Standorten.',
    }),
    definePermission({
      key: 'deposits.customerReturn.read',
      label: 'Leergutrücknahmen lesen',
      group: GROUP,
      description: 'Belege über zurückgenommenes Leergut an den eigenen Standorten.',
    }),
    definePermission({
      key: 'deposits.customerReturn.create',
      label: 'Leergut von Kunden zurücknehmen',
      group: GROUP,
      description: 'Im Markt oder beim Kunden: Leergut zählen, gutschreiben oder auszahlen.',
    }),
    definePermission({
      key: 'deposits.supplierReturn.read',
      label: 'Leergutrückgaben an Lieferanten lesen',
      group: GROUP,
    }),
    definePermission({
      key: 'deposits.supplierReturn.create',
      label: 'Leergut an Lieferanten zurückgeben',
      group: GROUP,
      description: 'Leergut geht mit dem Fahrzeug des Lieferanten zurück; sein Leergutkonto und der Leergutbestand sinken.',
    }),
  ],
})
